// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"327":"0bfdbabb","490":"afd431bc"}[chunkId] + ".css";
};